import React, {Fragment, useState} from "react";
import {replaceNewExceptionFields, selectOneItem} from "./permissionFunctions"
import ReactDOM from "react-dom";
import {ModalToRoot} from "../../../Modal/ModalToRoot";
import SectionViewModal from "./SectionViewModal";
import objectDataHolder from "../../Hooks/ObjectDataHolder";


interface mapV {
  EnName: string;
  FaLabel: string;
  exceptionFields: [];
  fields: [];
  value: Number;
}

const SectionView = ({sectionKey, data, setData,showAdvance}) => {

  const sectionData = data[sectionKey];
  const [modal, setModal] = objectDataHolder({
    isOpen: false, data: {},
    sectionKey: '',
  })


  const checkBoxChangeHandler = (e, EnName) => {
    const result = selectOneItem(data, sectionKey, EnName, e.target.checked)
    setData(result)
  }
  const detailsClickHandler = (object) => {
    setModal({isOpen: true, data: object, sectionKey})
  }

  const modalSubmit = (exceptionFields: [], EnName, sectionKey) => {
    // Hi Here is New exceptionFields and should Replace  in object with same EnName
    setData(replaceNewExceptionFields(data, exceptionFields, EnName, sectionKey))
  }

  return (
    <>
      {modal.isOpen &&
        <ModalToRoot
          // title={modal.data.FaLabel}
          // onClickCloseFunction={() => setModal({isOpen: false})}
        >
          <SectionViewModal isOpen={modal.isOpen}
                            setIsOpen={setModal}
                            modal={modal}
                            onSubmit={modalSubmit}/>
        </ModalToRoot>}
      <div className={'check__box__section'}>
        {sectionData.map((v: {}, index: Number) => {
          const {EnName, FaLabel, exceptionFields, fields, value}: mapV = v
          const uniqId = sectionKey + index;
          return <Fragment key={uniqId}>
            <div className={'single__check__box'}>
              <input
                onChange={(e) => checkBoxChangeHandler(e, EnName)}
                type="checkbox" id={uniqId} checked={value === 1}/>
              <label htmlFor={uniqId}>{FaLabel}</label>
              {showAdvance && fields.length > 0 &&
                <span
                  onClick={() => detailsClickHandler(v, sectionKey)}
                  title={'جزئیات'}>
                <i className="fa fa-plus plus__icon"></i>
              </span>
              }
            </div>
          </Fragment>
        })}
      </div>
    </>
  );
};

export default SectionView;
